// Model
import { ApiResponse } from '../models/api-response.model';
import { Dropdown } from '@core/models/dropdown.model';
// Angular
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// RxJS
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CryptoHttpService {

  constructor(private http: HttpClient) { }

  getCryptoTokens(): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/cryptotokens`).pipe(
      map(res => res.data.rows)
    );
  }
}
